import { createSlice, isAnyOf, type PayloadAction } from '@reduxjs/toolkit';

import { groupApi } from '@/api/queries/group';
import { type GroupFriends } from '@/common/types/groupFriendsType';

interface GroupState {
  group: GroupFriends | null;
}

const initialState: GroupState = {
  group: null,
};

const groupFriendsSlice = createSlice({
  name: 'groupFriends',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addMatcher(
      isAnyOf(
        groupApi.endpoints.getUserFriendsGroup.matchFulfilled,
        groupApi.endpoints.createUserFriendsGroup.matchFulfilled,
        groupApi.endpoints.acceptInviteToFriendsGroup.matchFulfilled,
        groupApi.endpoints.removeParticipantFromFriendsGroup.matchFulfilled,
        groupApi.endpoints.changeFriendsGroupName.matchFulfilled,
        groupApi.endpoints.leaveFromFriendsGroup.matchFulfilled,
      ),
      (state, { payload }: PayloadAction<GroupFriends | void>) => {
        state.group = payload || null;
      },
    );
    builder.addMatcher(
      groupApi.endpoints.joinFriendsGroup.matchFulfilled,
      (state, { payload }) => {
        if (payload.group) state.group = payload.group;
      },
    );
  },
});

export default groupFriendsSlice.reducer;
